'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export function Time(t0) {
  const $ = _c(13);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      arg: "",
      cet: ""
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [time, setTime] = useState(t1);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const updateTime = () => {
        setTime({
          arg: new Date().toLocaleTimeString(undefined, {
            timeZone: "America/Argentina/Buenos_Aires",
            hour: "2-digit",
            minute: "2-digit",
            localeMatcher: "best fit"
          }),
          cet: new Date().toLocaleTimeString(undefined, {
            timeZone: "CET",
            hour: "2-digit",
            minute: "2-digit",
            localeMatcher: "best fit"
          }),
          wet: new Date().toLocaleTimeString(undefined, {
            timeZone: "WET",
            hour: "2-digit",
            minute: "2-digit",
            localeMatcher: "best fit"
          })
        });
      };
      updateTime();
      const timer = setInterval(updateTime, 60000);
      return () => clearInterval(timer);
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  if (!(time.arg && time.cet)) {
    return null;
  }
  let t4;
  if ($[3] !== time.arg) {
    t4 = <p className="caption smb-40 dt:mb-0 ">ARG {time.arg}</p>;
    $[3] = time.arg;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== time.cet) {
    t5 = <p className="caption smb-40 dt:mb-0 col-start-3">CET {time.cet}</p>;
    $[5] = time.cet;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== time.wet) {
    t6 = <p className="caption smb-40 dt:mb-0 col-start-3">WET {time.wet}</p>;
    $[7] = time.wet;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = <div className="dr-grid dt:col-start-3 dt:col-span-2 col-span-full dt:flex dt:flex-col ">{t4}{t5}{t6}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}